import { validate } from '@reckon-web/forms';

export const required = () => {
  return validate((value: any) => {
    validate.required(value);
    return value;
  });
};

export const requiredEmail = () => {
  return validate((value: any) => {
    validate.email(value);
    return value;
  });
};

export const trimspace = () => {
  return validate.object((value: any, objectValue) => {
    if (value !== '' && !value.replace(/\s/g, '').length) {
      validate.error('Cannot only include the space character');
    }
    if (value.charAt(0) === ' ') {
      validate.error('Cannot lead with the space character');
    }
    if (value.substr(value.length - 1) === ' ') {
      validate.error('Cannot end with the space character');
    }
    return value;
  });
};
